import React from 'react';
import { Mail, Instagram, Facebook, Youtube, Info, Phone, Send } from 'react-feather';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white py-1 px-6 mt-auto sticky bottom-0 left-0 right-0 z-50">
      <div className="container mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between py-1">
          {/* Copyright Section */}
          <div className="text-center sm:text-left mb-1 sm:mb-0">
            <p className="text-xs font-medium">
              © {currentYear} TenaRx Admin Panel. All rights reserved.
            </p>
            <p className="text-xs text-gray-400 mt-0">
              Developed with ❤️ for better healthcare management
            </p>
          </div>
          
          {/* Links Section */}
          <div className="flex items-center space-x-4">
            <Link 
              to="/about" 
              className="text-xs text-gray-400 hover:text-white transition-colors duration-200 flex items-center"
              title="About TenaRx"
            >
              <Info size={14} className="mr-1" />
              About
            </Link>
          </div>
          
          {/* Social Media Links */}
          <div className="flex items-center space-x-4">
            <span className="text-xs text-gray-400 mr-2">Connect:</span>
            <div className="flex space-x-3">
              <span className="text-xs text-gray-400">+251980472038</span>
              <a 
                href="mailto:contact@tenarx.net?subject=Inquiry%20from%20TenaRx&body=Hello%20TenaRx%20Team," 
                className="text-gray-400 hover:text-red-500 transition-colors duration-200 transform hover:scale-110"
                title="Email"
              >
                <Mail size={16} />
              </a>
              <a 
                href="https://t.me/tenarxnet" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-200 transform hover:scale-110"
                title="Telegram"
              >
                <Send size={16} />
              </a>
              <a 
                href="https://instagram.com/tenarx_net" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors duration-200 transform hover:scale-110"
                title="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a 
                href="https://www.facebook.com/share/1E4CAcdLpC/?mibextid=wwXIfr"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
                title="Facebook"
              >
                <Facebook size={16} />
              </a>
              <a 
                href="https://tiktok.com/@tenarx_net" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-100 transition-colors duration-200 transform hover:scale-110"
                title="TikTok"
              >
                <Youtube size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
